"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Power, Phone, Mail, MapPin, Facebook, Twitter, Linkedin, ChevronRight } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-zinc-800/50 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-zinc-400 hover:text-primary transition-colors flex items-center gap-2 text-sm group">
            <ChevronRight className="size-3 text-primary/50 group-hover:text-primary transition-colors" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const socialLinks = [{
    icon: Facebook,
    url: "#"
  }, {
    icon: Twitter,
    url: "#"
  }, {
    icon: Linkedin,
    url: "#"
  }];
  return <section id="footer" className="bg-background">
      <div className="relative bg-zinc-950 text-zinc-300 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/carbon_fiber_texture.png)] bg-cover bg-center border-t border-zinc-800">
        {}
        <div className="absolute inset-0 bg-zinc-950/90 mix-blend-multiply pointer-events-none"></div>
        
        <div className="container mx-auto px-4 py-16 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            
            {}
            <div className="space-y-6">
              <Link to="/" className="inline-block">
                <img src="https://nice-cricket.10web.cloud/wp-content/uploads/2026/04/gridspan.png" alt="GRIDSPAN INSTALLATIONS LTD" className="w-auto !h-[81px]" />
              </Link>
              <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
                Specialising in preparing sites for seamless electrical installations. We ensure every project is ready for the next phase with safety and precision.
              </p>
              <div className="flex flex-wrap gap-2 pt-2">
                <Badge variant="outline" className="border-zinc-700 text-zinc-300 bg-zinc-900/50 font-mono text-[10px] tracking-wider">
                  ISO 9001 CERTIFIED
                </Badge>
                <Badge variant="outline" className="border-zinc-700 text-zinc-300 bg-zinc-900/50 font-mono text-[10px] tracking-wider">
                  NICEIC APPROVED
                </Badge>
              </div>
            </div>

            {}
            <div>
              <h3 className="text-zinc-100 font-semibold mb-6 font-default tracking-wide uppercase text-sm">
                Quick Links
              </h3>
              <MenuProvider menu_id="17">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div>
              <h3 className="text-zinc-100 font-semibold mb-6 font-default tracking-wide uppercase text-sm">
                Contact
              </h3>
              <ul className="space-y-5">
                <li className="flex items-start gap-3 group">
                  <div className="p-2 rounded-md bg-zinc-900/50 border border-zinc-800 group-hover:border-primary/50 transition-colors shrink-0">
                    <Phone className="size-4 text-primary" />
                  </div>
                  <div className="pt-1">
                    
                    <p className="font-mono text-zinc-300 text-sm group-hover:text-primary transition-colors">
                      {"" || "---"}
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-3 group">
                  <div className="p-2 rounded-md bg-zinc-900/50 border border-zinc-800 group-hover:border-primary/50 transition-colors shrink-0">
                    <Mail className="size-4 text-primary" />
                  </div>
                  <div className="pt-1">
                    
                    <p className="text-zinc-300 text-sm group-hover:text-primary transition-colors">
                      {"" || "---"}
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-3 group">
                  <div className="p-2 rounded-md bg-zinc-900/50 border border-zinc-800 group-hover:border-primary/50 transition-colors shrink-0">
                    <MapPin className="size-4 text-primary" />
                  </div>
                  <div className="pt-1">
                    
                    <p className="text-zinc-300 text-sm leading-relaxed">18 Kingfisher Close, Bedford, England, MK41 7JR</p>
                  </div>
                </li>
              </ul>
            </div>

            {}
            

          </div>

          {}
          <div className="mt-16 pt-6 border-t border-zinc-800/80 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-zinc-500 text-xs font-mono">© 2025 GRIDSPAN INSTALLATIONS LTD. ALL RIGHTS RESERVED.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; COMPANY NUMBER: 16683169&nbsp;</p>
            
            
          </div>
        </div>
      </div>
    </section>;
}